import { render } from "./PatientForm.vue?vue&type=template&id=2d6005b2&scoped=true"
import script from "./PatientForm.vue?vue&type=script&lang=ts"
export * from "./PatientForm.vue?vue&type=script&lang=ts"

import "./PatientForm.vue?vue&type=style&index=0&id=2d6005b2&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-2d6005b2"

export default script